import script from "./EResizer.vue?vue&type=script&lang=ts&setup=true"
export * from "./EResizer.vue?vue&type=script&lang=ts&setup=true"

import "./EResizer.vue?vue&type=style&index=0&id=5910b34e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5910b34e"]])

export default __exports__